import { storage } from '@guardian/libs';
import * as z from 'zod/mini';
// ----- Functions ----- //
function setLocal(key, value) {
    storage.local.isAvailable() && storage.local.set(key, value);
}
function getLocal(key) {
    if (!storage.local.isAvailable()) {
        return null;
    }
    const data = storage.local.get(key);
    if (data !== null && data !== undefined) {
        return data;
    }
    try {
        const item = window.localStorage.getItem(key);
        const data = item && JSON.parse(item);
        return data ?? null;
    }
    catch (error) {
        console.error(`Failed to parse ${key} from local storage`, error);
        return null;
    }
}
function setSession(key, value) {
    storage.session.isAvailable() && storage.session.set(key, value);
}
function getSession(key, schema) {
    if (!storage.session.isAvailable()) {
        return null;
    }
    const data = storage.session.get(key);
    if (data !== null && data !== undefined) {
        const result = z.safeParse(schema, data);
        return result.success ? result.data : null;
    }
    try {
        const item = window.sessionStorage.getItem(key);
        const parsedData = item && JSON.parse(item);
        const result = z.safeParse(schema, parsedData ?? null);
        return result.success ? result.data : null;
    }
    catch (error) {
        console.error(`Failed to parse ${key} from session storage`, error);
        return null;
    }
}
// ----- Exports ----- //
export { setLocal, getLocal, setSession, getSession };
